.purchase {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 1.5rem;
}

.purchaseError {
  position: relative;
  top: 0.5rem;
  height: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
}

.purchaseMessage {
  display: flex;
  gap: 0.4rem;
  align-items: center;
  margin-right: 1rem;
  border-radius: 0.3rem;
  padding: 0.15rem 0.3rem;
}

.purchaseInput {
  width: 55%;
}

.purchaseInputText {
  text-align: right;
}

.lotsInput {
  margin-left: 1rem;
  width: 35%;
}

.button {
  display: flex;
  width: 45%;
  margin: 0 1rem;
}

.errorText {
  height: 5%;
}

@media (max-width: 550px) {
  .purchageMessage {
    height: fit-content;
    width: fit-content;
    padding: 0.15rem;
  }
}

@media (min-width: 551px) and (max-width: 780px) {
  .purchageMessage {
    font-size: 0.2rem;
  }

  .purchageMessage {
    margin-top: 0.8rem;
    margin-left: 1rem;
  }
}
